var defaultOptions = {
  responseAdapter: function (resp) {
    var moment = require('moment');

    for (let index = 0; index < resp.results.length; index++) {
      let element = resp.results[index];
      element.date = moment(new Date(1925, 0, 1).getTime() + Math.random() * (new Date(2018, 0, 1).getTime() - new Date(1925, 0, 1).getTime()));
      // element.date = moment(new Date(1925, 0, 1).getTime() + Math.random() * (new Date(2018, 0, 1).getTime() - new Date(1925, 0, 1).getTime())).format('DD/MM/YYYY')
      // console.log(element);
    }
    return {
      data: resp.results,
      count: resp.count
    };
  },
  details: false,
  actions: false,
  multiSeparator: ',',
  rangeSeparator: ':',
  allowMulti: false,
  allowRange: false,
  requestFunction: function (data) {
    let params = Object.keys(data.search);

    // detect if user wants to filter multiple elements or filter given a range

    // for each column in the table
    for (let index = 0; index < params.length; index++) {
      const element = params[index];

      let val = data.search[element];
      let count = 0;

      // If column is date range -> parse values
      if (this.options.dateColumns.indexOf(element) > -1) {
        data[element + '__gte'] = val.start;
        data[element + '__lte'] = val.end;
      } else if (this.filterableColumns.indexOf(element) > -1) { // If column in text filter list
        if ((val.indexOf(this.options.multiSeparator) > -1) && this.options.allowMulti) { // If multiple values
          // console.log('multiple')
          data[element + '__in'] = val.split(this.options.multiSeparator);
        } else if ((val.indexOf(this.options.rangeSeparator) > -1) && this.options.allowRange) { // If range
          let loc = val.indexOf(this.options.rangeSeparator);
          while (loc !== -1) {
            loc = val.indexOf(this.options.rangeSeparator, loc + 1);
            count++;
          }
          if (count > 1) {
            // console.log('too much range')
            data[element] = val;
          } else {
            // console.log('range')
            val = val.split(this.options.rangeSeparator);
            data[element + '__gte'] = val[0];
            data[element + '__lte'] = val[1];
            delete data[element];
          }
        } else { // If normal text input
          data[element + '__icontains'] = val;
        }
      } else { // else, return the value
        data[element] = val;
      }
    }
    if (params.length > 0) {
      delete data.search;
    }
    delete data.byColumn;

    return this.$http.get(this.url, { params: data }).then(function (data) {
      return data.json();
    }, function (e) {
      this.dispatch('error', e);
    }.bind(this));
  },
  params: {
    'paginated': true
  },
  orderBy: {
    ascending: false
  },
  requestKeys: {
    query: 'search',
    orderBy: 'ordering',
    limit: 'page_size'
  },
  pagination: {
    chunk: 10,
    dropdown: false
  },
  skin: 'table-hover',
  sortIcon: {
    base: 'fa',
    up: 'fa-caret-down',
    down: 'fa-caret-up',
    is: 'fa-sort'
  },
  datepickerOptions: {
    showDropdowns: true
  },
  filterable: [],
  filterByColumn: false,
  draggable: false
};

import DateT from './DateT.vue';
import Multiselect from 'vue-multiselect';

export default {
  name: 'Table',
  components: { Multiselect, DateT },
  props: {
    options: {
      default: () => (
        defaultOptions
      )
    },
    columns: {
      default: () => (
        [{text: 'id'}]
      )
    },
    url: {
      default: ''
    }
  },
  data: function () {
    return {
      finalOptions: defaultOptions,
      columnsTexts: [],
      loading: true,
      multiselectColumns: [],
      selectColumns: [],
      elements: []
    };
  },
  beforeMount: function () {
    this.loading = true;

    // Overwrite options from props
    this.finalOptions = Object.assign({...this.finalOptions}, this.options);

    // Add buttons column
    if (this.finalOptions.actions) {
      if (!(this.columns[0].text === 'actions')) {
        this.columns.unshift({text: 'actions', type: 'status', template: this.finalOptions.actions});
      }
    }

    // Get texts for table header
    this.columnsTexts = this.columns.map(e => { return e.text; });

    // Get list of multiselect columns
    this.multiselectColumns = this.columns.filter(e => { return (e.filterable && e.type === 'multiselect'); });
    // Get filterable columns from the = select
    this.selectColumns = this.columns.filter(e => { return (e.filterable && e.type === 'select'); });

    // Get list of filterable columns
    let filterable = this.columns.filter(e => { return (e.filterable && e.type !== 'multiselect' && e.type !== 'select'); });

    // If filterByColumn set to true get the list of columns to apply this feature
    if (this.finalOptions.filterByColumn) {
      if (filterable.length === 0) {
        // If any column is given, set all columns available to filter
        this.finalOptions.filterable = this.columnsTexts;
      } else {
        this.finalOptions.filterable = filterable.map(e => { return e.text; });
      }

      // this.finalOptions.listColumns = Object.assign({}, ...this.columns.filter(e => { return e.type === 'select' }).map(e => { return { [e.text]: e.options.map(e2 => { return { id: e2, text: e2 } }) } }))
    }

    // Get columns with type = 'status' and assign the template status
    this.finalOptions.templates = Object.assign({}, ...this.columns.filter(e => { return e.type === 'status'; }).map(e => { return { [e.text]: e.template }; }));

    // Get columns with type = 'date' and assign the template status
    this.finalOptions.dateColumns = this.columns.filter(e => { return e.type === 'date'; }).map(e => { return e.text; });

    // Get sortable columns, If no column defined, all columns will be sortable
    let sort = this.columns.filter(e => { return e.sortable === true; }).map(e => { return e.text; });
    if (sort.length > 0) {
      this.finalOptions.sortable = sort;
    }
    this.loading = false;
  },
  mounted: function () {

    // if (this.$children[1].$el.classList.contains('table-header-hover')) {
    //   // Remove class to avoid hide header when calendar appears
    //   window.$('#VueTables__date-filter').on('show.daterangepicker', function (ev, picker) {
    //     let a = findAncestor(this, 'table-header-hover')
    //     if (a) {
    //       a.classList.remove('table-header-hover')
    //     }
    //   })
    //   window.$('#VueTables__date-filter').on('hide.daterangepicker', function (ev, picker) {
    //     let a = findAncestor(this, 'VueTables')
    //     console.log(a)
    //     if (a) {
    //       a.classList.add('table-header-hover')
    //     }
    //   })
    // }
  },
  methods: {
    refresh: function () {
      this.$refs.table.refresh();
    },
    rowClicked: function (object) {
      if (this.url === 'testitems/') {
        this.$router.push({ name: 'ItemDetail', params: { id: object.id } });
      } else if (this.url === 'jobs/') {
        this.$router.push({name: 'JobDetail', params: { id: object.id }});
      }
    },
    getTableClass: function () {
      let tableClass =
        localStorage.getItem('kb_nav') === 'Non-strict' ||
        !localStorage.getItem('kb_nav')
          ? 'table-hide-nativetoggler'
          : 'table-hide-nativetoggler';
      // if (this.finalOptions.actions) {
      //   tableClass += ' table-actions-hover'
      // }
      return tableClass;
    },
    updateSearch: function (column) {
      // Set values to table queryparams
      let query = '';
      try {
        query = column.selected.join(',');
      } catch (error) {
        query = column.selected;
      }

      this.$refs.table.customQueries[column.text] = query;
      this.$refs.table.getData(); // this will send the request
    },
    downData: function (val) {
      this.$http.get('testitems2/').then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.elements.push({title: response.data[i].title, description: response.data[i].description});
        }
        if (val === 'csv') {
          this.downloadCSV({ filename: 'elements-' + val + '.csv' });
        } else if (val === 'excel') {
          this.downloadExcel({ filename: 'elements-' + val + '.xlsx' });
        }
        this.elements = [];
      });
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ',';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    },
    downloadCSV: function (args) {
      var data, filename, link;

      var csv = this.convertArrayOfObjectsToCSV({
        data: this.elements
      });
      if (csv == null) return;

      filename = args.filename || 'export.csv';

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      data = encodeURI(csv);

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    },
    downloadExcel: function (args) {
      var data, filename, link;

      var csv = this.convertArrayOfObjectsToCSV({
        data: this.elements
      });
      if (csv == null) return;

      filename = args.filename || 'export.csv';

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      data = encodeURI(csv);

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Modules/Table/Table.js?vue&type=script&lang=js&